import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of phone packages based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('phone_packages', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single phone package based on his ID
 *
 * @param id the of the phone package requested
 */
export function getFromId(id) {
  return baseGetFromId('phone_packages', id);
}

/**
 * Get a single phone package based on his ID
 *
 * @param id the of the phone package requested
 */
export function getSafeguardFromId(id) {
  return baseGetFromId('phone_packages', id, 'safeguard');
}

/**
 * Get a single phone package based on his ID
 *
 * @param id the of the phone package requested
 */
export function getSafeguardPriceFromId(id) {
  return baseGetFromId('phone_packages', id, 'safeguard_price');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single phone package based on his ID
 *
 * @param id the of the phone package requested
 * @param data the new data of the phone package
 */
export function editFromId(id, data) {
  return baseEditFromId('phone_packages', id, data);
}

/**
 * Edit a single phone package based on his ID
 *
 * @param id the of the phone package requested
 * @param data the new data of the phone package
 */
export function editSafeguardFromId(id, data) {
  return baseEditFromId('phone_packages', id, data, 'safeguard');
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new phone package
 *
 * @param data the new data of the phone package
 */
export function newItem(data) {
  return baseNewItem('phone_packages', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all phone packages to serve in a dropdown form choice
 */
export function fetchPhonePackages() {
  return baseIndex('phone_packages', 1, 0);
}
